module.exports = __webpack_public_path__ + "img/JederIstSeinesGlückesSchmied.44945ce7.jpg";